import '../App.css';
import Seo from '../components/common/atoms/Seo';
import seoData from '../json/seo.json';
import Header from '../components/menu/organisms/Header';
import Footer from '../components/footer/Footer';
import TopContent from '../components/top/organisms/TopContent';
import MVmotion from '../components/motion/organisms/MVmotion';
import ScrollToTopButton from '../components/common/atoms/ScrollToTopbutton';
import ScrollDownButton from '../components/top/atoms/ScrollDownButton';

/**
 * トップページ
 * @returns 
 */
function Home() {

  return (
    <div>
      <ScrollToTopButton />
      <Seo description={seoData.pages.home.description} path='/' />

      <header>
        <Header />
      </header>

      <main className="main-content">
        <MVmotion/>
        <ScrollDownButton/>
        <TopContent />
      </main>

      <footer>
        <Footer />
      </footer>

    </div>
  );
}

export default Home;
